import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "promotion-name-date" },
    [
      _c(
        "div",
        { staticClass: "promotion-name-date__name-wrapper" },
        [
          _vm.showIcon
            ? _c(
                "div",
                { staticClass: "promotion-name-date__name-wrapper--icon-type" },
                [
                  _c(
                    VTooltip,
                    {
                      attrs: { "z-index": "400", top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "span",
                                  _vm._g(_vm._b({}, "span", attrs, false), on),
                                  [
                                    _c("icon", {
                                      attrs: { "icon-name": _vm.iconName },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4145135773
                      ),
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("toSentenceCase")(
                              _vm.$t(
                                `planning.promotionsViewer.promotionType.${_vm.promotionType.toLowerCase()}`
                              )
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("vuex-text-field", {
            ref: "promotionName",
            staticClass: "promotion-name-date__text",
            attrs: {
              disabled: _vm.editNameDisabled,
              getter: () => _vm.getPromotionNameModel(),
              setter: (value) => _vm.setPromotionNameModel(value),
              white: true,
              validations: _vm.promotionNameValidation,
              placeholder: _vm._f("toSentenceCase")(
                _vm.$t("planning.promotionsViewer.promotionName")
              ),
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
              blur: _vm.saveName,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("losenge-date-display", {
        attrs: { "start-date": _vm.startDate, "end-date": _vm.endDate },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }